// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor, safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Loader from "@store/Library/Components/Toolkit/Loader";
import constants from "@store/constants";
import { getFilteredConfigurable } from "@store/Framework/Store/Store/Data/FilteredConfigurable/FilteredConfigurableSelector";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps extends ExpandStyles<ProductAvailabilityWithPickupStyles> {
    dcneAvailability?: string;
    isProductDetailsPage?: boolean;
    isScratchAndDent?: string; // returns "True"
    canAddToCart?: boolean;
    isStandardKit?: boolean;
}

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => {
    const filteredConfigurableData = getFilteredConfigurable(state, ownProps.parentProductId);
    return {
        parentProductId: ownProps.parentProductId,
        kits: getProductState(state, ownProps.parentProductId).value?.properties?.productsInKit,
        productSettings: getSettingsCollection(state).productSettings,
        pickUpWarehouse: state.context.session.pickUpWarehouse,
        filteredConfigurableData,
    };
};
const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId;

export interface ProductAvailabilityWithPickupStyles {
    container?: GridContainerProps;
    stockGridItem?: GridItemProps;
    stockGridItemFull?: GridItemProps;
    stockPickupTitle?: TypographyPresentationProps;
    stockShippingTitle?: TypographyPresentationProps;
    stockAsciiIcon?: TypographyPresentationProps;
    stockIconMessageWrapper?: InjectableCss;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    messageSubText?: TypographyPresentationProps | InjectableCss;
    messageSubLink?: InjectableCss;
    modalTitles?: TypographyPresentationProps;
    legalText?: TypographyPresentationProps;
    trackingLink?: LinkPresentationProps;
    replenishmentModal?: ModalPresentationProps;
}

export const productAvailabilityWithPickupStyles: ProductAvailabilityWithPickupStyles = {
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
            background-color: ${getColor("common.accent")};
            padding: ${pxToRem(20)};
        `,
    },
    stockGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
        `,
    },
    stockGridItemFull: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    stockPickupTitle: {
        css: css`
            text-transform: uppercase;
            font-size: ${pxToRem(16)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            color: ${getColor("text.main")};
            padding-left: 1.7em;
            position: relative;

            &::before {
                content: "\\e91e";
                font-family: icons, sans-serif;
                font-weight: ${x => x.theme.design.typography.weight.base};
                font-style: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                font-size: ${pxToRem(20)};
                position: absolute;
                top: 50%;
                left: 0;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        `,
    },
    stockAsciiIcon: {
        css: css`
            font-family: icons, sans-serif;
            font-weight: ${x => x.theme.design.typography.weight.base};
            font-style: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            margin-right: 0.4em;
        `,
    },
    stockShippingTitle: {
        css: css`
            text-transform: uppercase;
            font-size: ${pxToRem(16)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            color: ${getColor("text.main")};
            padding-left: 1.7em;
            position: relative;

            &::before {
                content: "\\e91b";
                font-family: icons, sans-serif;
                font-weight: ${x => x.theme.design.typography.weight.base};
                font-style: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                font-size: ${pxToRem(20)};
                position: absolute;
                top: 50%;
                left: 0;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        `,
    },
    messageText: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    messageSubText: {
        css: css`
            font-size: ${pxToRem(12)};
        `,
    },
    messageSubLink: {
        css: css`
            display: block;
            color: inherit;
            font-size: ${pxToRem(12)};
            text-decoration: underline;
            &:hover {
                text-decoration: none;
            }
        `,
    },
    modalTitles: {
        css: css`
            display: block;
            padding-top: ${pxToRem(38)};
            padding-bottom: ${pxToRem(15)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            font-size: ${pxToRem(24)};

            &:first-child {
                padding-top: 0;
            }
        `,
    },
    legalText: {
        css: css`
            margin-top: ${pxToRem(8)};
            font-size: ${pxToRem(12)};
        `,
    },
    stockIconMessageWrapper: {
        css: css`
            flex-direction: row;
        `,
    },
    inventoryMessage: {
        css: css`
            display: flex;
            align-items: left;
            flex-direction: column;

            ${IconWrapper} {
                margin-right: ${pxToRem(10)};
            }

            a,
            button {
                color: inherit;
            }
        `,
    },
    trackingLink: {
        css: css`
            display: inline-block;
            width: ${pxToRem(24)};
            height: ${pxToRem(24)};
            margin: 0 ${pxToRem(3)};
            background-image: url("data:image/svg+xml,%0A%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'%3E%3Cpath d='M3 18h-2c-.552 0-1-.448-1-1v-2h15v-9h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.121-.728 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-6c0 1.656-1.344 3-3 3s-3-1.344-3-3zm3-1.2c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm12 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-4-2.8h-14v-10c0-.552.448-1 1-1h12c.552 0 1 .448 1 1v10zm3-6v3h4.715l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.42z'/%3E%3C/svg%3E");

            span {
                display: none;
            }
        `,
    },
    replenishmentModal: { sizeVariant: "large" },
};

const InventoryMessage = styled.div<{ color: string }>`
    color: ${props => safeColor(resolveColor(props.color, props.theme)).rgb().string()};
`;

const getAvailabilityColor = (availability?: any) => {
    const availabilityType = availability?.StatusName;
    if (availabilityType === "Available") {
        return "success";
    }

    if (availabilityType === "AvailableSoon") {
        return "warning";
    }

    if (availabilityType === constants.availability.notAvailable) {
        return "danger";
    }

    if (availabilityType === "Restricted") {
        return "text";
    }

    if (!availability.IsAvailableAtCustomerWarehouse) {
        return "text";
    }

    return "success";
};

const iconCheck = "&#59657;";
const iconX = "&#59658;";
const iconNotAvailable = "&#59679;";

const getAvailabilityIcon = (availability: any, type: string) => {
    const availabilityType = availability?.StatusName;

    if (type === "pickup" && !availability.IsAvailableAtCustomerWarehouse) {
        return iconNotAvailable;
    }

    if (availabilityType === "Available") {
        return iconCheck;
    }

    if (availabilityType === "AvailableSoon") {
        return iconCheck;
    }

    if (availabilityType === constants.availability.notAvailable) {
        return iconCheck;
    }

    if (availabilityType === "Restricted") {
        return iconX;
    }

    return iconCheck;
};

const getScratchAndDentAvailabilityIcon = (canAddToCart: boolean | undefined, availability?: any) => {
    if (!canAddToCart) {
        return iconX;
    }

    return iconCheck;
};

const styles = productAvailabilityWithPickupStyles;

const ProductAvailabilityWithPickup = ({
    dcneAvailability,
    isProductDetailsPage,
    isScratchAndDent,
    pickUpWarehouse,
    filteredConfigurableData,
    canAddToCart,
    isStandardKit,
    kits,
    extendedStyles,
    overridedStyles,
}: Props) => {
    const styles = useExpandProps(productAvailabilityWithPickupStyles, extendedStyles, overridedStyles);
    const [replenishmentModalIsOpen, setReplenishmentModalIsOpen] = useState(false);
    const [warehousesModalIsOpen, setWarehousesModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<[] | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const availability = React.useMemo(() => {
        if (isStandardKit) {
            return filteredConfigurableData?.availability;
        }
        if (dcneAvailability) {
            return JSON.parse(dcneAvailability);
        }
        return undefined;
    }, [isStandardKit, filteredConfigurableData, dcneAvailability]);

    if (!availability || availability === undefined) {
        return null;
    }

    const warehousesModalCloseHandler = () => {
        setWarehousesModalIsOpen(false);
    };

    const replenishmentModalCloseHandler = () => {
        setReplenishmentModalIsOpen(false);
    };

    const getDistanceFromLocationInMi = (lat1: number, lon1: number, lat2: any, lon2: any) => {
        const radius = 6371; // Radius of the earth in km
        const kmToMiles = 0.621371;
        const p = Math.PI / 180;
        const latitudeDegrees = Math.sin(((lat2 - lat1) * p) / 2);
        const longitudeDegrees = Math.sin(((lon2 - lon1) * p) / 2);

        const a =
            latitudeDegrees * latitudeDegrees +
            Math.cos(lat1 * p) * Math.cos(lat2 * p) * longitudeDegrees * longitudeDegrees;

        return radius * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) * kmToMiles;
    };

    const prepareWarehousesModal = () => {
        const defaultLat = constants.geolocation.defaultLat;
        const defaultLong = constants.geolocation.defaultLong;
        if (!navigator.geolocation) {
            sortWarehouses(defaultLat, defaultLong);
        }
        navigator.geolocation.getCurrentPosition(
            position => {
                sortWarehouses(position.coords.latitude, position.coords.longitude);
            },
            e => {
                sortWarehouses(defaultLat, defaultLong);
            },
        );
    };

    const sortWarehouses = (lat: number, long: number) => {
        const warehouses = availability.Warehouses;
        const sortedWarehouses = warehouses.slice(0).sort((itemA: any, itemB: any) => {
            const distanceA = getDistanceFromLocationInMi(lat, long, itemA.Latitude, itemA.Longitude);
            const distanceB = getDistanceFromLocationInMi(lat, long, itemB.Latitude, itemB.Longitude);
            return distanceA > distanceB ? 1 : -1;
        });
        setWarehouses(sortedWarehouses);
        setIsLoading(false);
    };

    const checkNearbyStoreClickHandler = () => {
        setWarehousesModalIsOpen(true);
        setIsLoading(true);
        prepareWarehousesModal();
    };

    const checkReplenishmentClickHandler = () => {
        setReplenishmentModalIsOpen(true);
    };
    const color = getAvailabilityColor(availability);

    const pickupIventoryTextComponent = (
        <InventoryMessage color={color} {...styles.inventoryMessage}>
            <>
                <Typography {...styles.stockPickupTitle}>{translate("Pickup")}</Typography>
                <StyledWrapper {...styles.stockIconMessageWrapper}>
                    <Typography
                        {...styles.stockAsciiIcon}
                        dangerouslySetInnerHTML={{ __html: getAvailabilityIcon(availability, "pickup") }}
                    ></Typography>
                    {((availability.IsAvailableAtCustomerWarehouse && availability.HasWarehouse) ||
                        (!availability.IsAvailableAtCustomerWarehouse &&
                            availability.IsAvailable &&
                            availability.HasWarehouse)) && (
                        <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                            {availability.QuantityAvailableForPickup > 0 && (
                                <>{availability.QuantityAvailableForPickup} </>
                            )}
                            {availability.StatusName !== "AvailableSoon" && (
                                <Typography>{translate("Store_ProductAvailability_AvailableForPickUp")}</Typography>
                            )}
                            {availability.StatusName === "AvailableSoon" && (
                                <Typography>{translate("Store_ProductAvailability_AvailableSoon")}</Typography>
                            )}{" "}
                            {translate("Store_ProductAvailability_AvailableIn")}
                            &nbsp;{availability.PickUpWarehouseLabel}
                        </Typography>
                    )}

                    {availability.IsAvailable && !availability.HasWarehouse && (
                        <Typography>
                            {availability.TotalQuantity} {translate("Store_ProductAvailability_AvailableForPickUp")}
                        </Typography>
                    )}

                    {!availability.IsAvailable && (
                        <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                            {translate("Store_ProductAvailability_AvailableForPickUp")}{" "}
                            {availability.IsUserAuthenticated && availability.HasWarehouse && (
                                <Typography>
                                    {translate("Store_ProductAvailability_AvailableIn")}{" "}
                                    {availability.PickUpWarehouseLabel}
                                </Typography>
                            )}
                        </Typography>
                    )}

                    {availability.IsRestricted && (
                        <Typography>{translate("Store_ProductAvailability_Restricted")}</Typography>
                    )}
                </StyledWrapper>

                {availability.IsUserAuthenticated && availability.HasWarehouse && (
                    <StyledWrapper>
                        {availability.StatusName === "Available" &&
                            availability.PickUpDelay.MaximumDays == null &&
                            availability.IsAvailableAtCustomerWarehouse && (
                                <>
                                    {availability.PickUpDelay.MinimumDays === 0 &&
                                        translate("Store_ProductAvailability_PickUp_AvailableNowMessage")}
                                    {availability.PickUpDelay.MinimumDays > 0 && (
                                        <>
                                            {availability.PickupAvailabilityStatusMessage}{" "}
                                            {translate("Store_ProductAvailability_InNetworkMessage")}{" "}
                                            {translate(
                                                "Store_ProductAvailability_PickUp_AvailableInNetworkMessage_Plural",
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        {availability.StatusName === "Available" &&
                            availability.PickUpDelay.MaximumDays == null &&
                            !availability.IsAvailableAtCustomerWarehouse && (
                                <Typography {...styles.messageSubText}>
                                    {availability.PickupAvailabilityStatusMessage}
                                    {availability.PickUpDelay.MinimumDays === "0" && (
                                        <Typography {...styles.messageSubText}>
                                            {translate("Store_ProductAvailability_PickUp_AvailableNowMessage")}
                                        </Typography>
                                    )}
                                    {availability.PickUpDelay.MinimumDays === "other" && (
                                        <Typography {...styles.messageSubText}>
                                            {availability.TotalQuantity}
                                            {translate("Store_ProductAvailability_InNetworkMessage")}
                                            {translate(
                                                "Store_ProductAvailability_PickUp_AvailableInNetworkMessage_Plural",
                                            )}
                                        </Typography>
                                    )}
                                </Typography>
                            )}

                        {availability.StatusName === "Restricted" && (
                            <Typography {...styles.messageSubText}>
                                {translate("Store_ProductAvailability_RestrictedMessage")}
                                {translate("Store_ProductAvailability_RestrictedMessage2")}
                            </Typography>
                        )}
                    </StyledWrapper>
                )}

                {availability.StatusName === constants.availability.notAvailable && (
                    <Typography {...styles.messageSubText}>
                        {translate("Store_ProductAvailability_PickUp_NotAvailableMessage")}
                    </Typography>
                )}

                {availability.StatusName === "AvailableSoon" && (
                    <Typography {...styles.messageSubText}>{availability.PickupAvailabilityStatusMessage}</Typography>
                )}

                {availability.StatusName !== constants.availability.notAvailable &&
                    availability.StatusName !== "Restricted" &&
                    availability.StatusName !== "AvailableSoon" && (
                        <Link {...styles.messageSubLink} onClick={checkNearbyStoreClickHandler}>
                            {translate("Store_ProductAvailability_CheckInventory")}
                        </Link>
                    )}
            </>
        </InventoryMessage>
    );

    const shippingIventoryTextComponent = (
        <InventoryMessage color={color} {...styles.inventoryMessage}>
            <>
                <Typography {...styles.stockShippingTitle}>{translate("Standard Shipping")}</Typography>
                <StyledWrapper {...styles.stockIconMessageWrapper}>
                    <Typography
                        {...styles.stockAsciiIcon}
                        dangerouslySetInnerHTML={{ __html: getAvailabilityIcon(availability, "shipping") }}
                    ></Typography>
                    <Typography {...styles.messageText}>
                        {availability.StatusName === "Available" && (
                            <>
                                {availability.QuantityAvailableForShipping} {availability.StatusName}
                            </>
                        )}
                        {availability.StatusName === "AvailableSoon" &&
                            translate("Store_ProductAvailability_AvailableSoon")}
                        {availability.StatusName === constants.availability.notAvailable &&
                            translate("Store_ProductAvailability_NotAvailable")}
                        {availability.StatusName === "Restricted" && translate("Store_ProductAvailability_Restricted")}
                    </Typography>
                </StyledWrapper>
                <Typography {...styles.messageSubText}>
                    {(availability.StatusName === "Available" || availability.StatusName === "AvailableSoon") && (
                        <>{availability.ShippingAvailabilityStatusMessage}</>
                    )}
                    {availability.StatusName === constants.availability.notAvailable && (
                        <>
                            {translate("Store_ProductAvailability_OutOfStockMessage")}{" "}
                            {translate("Store_ProductAvailability_OutOfStockPhoneNumber")}
                        </>
                    )}
                    {availability.StatusName === "Restricted" && (
                        <>
                            {translate("Store_ProductAvailability_RestrictedMessage")}{" "}
                            {translate("Store_ProductAvailability_RestrictedMessage2")}
                        </>
                    )}
                </Typography>

                {availability.StatusName === "AvailableSoon" && availability.HasPurchaseOrders && (
                    <Link {...styles.messageSubLink} onClick={checkReplenishmentClickHandler}>
                        {translate("Store_ProductAvailability_CheckReplenishment")}
                    </Link>
                )}
            </>
        </InventoryMessage>
    );

    const inlineShippingIventoryTextComponent = (
        <InventoryMessage color={color} {...styles.inventoryMessage}>
            <>
                <StyledWrapper {...styles.stockIconMessageWrapper}>
                    <Typography
                        {...styles.stockAsciiIcon}
                        dangerouslySetInnerHTML={{ __html: getAvailabilityIcon(availability, "shipping") }}
                    ></Typography>
                    <Typography {...styles.messageText}>
                        {availability.StatusName === "Available" && <>{availability.StatusName}</>}
                        {availability.StatusName === "AvailableSoon" &&
                            translate("Store_ProductAvailability_AvailableSoon")}
                        {availability.StatusName === constants.availability.notAvailable &&
                            translate("Store_ProductAvailability_NotAvailable")}
                        {availability.StatusName === "Restricted" && translate("Store_ProductAvailability_Restricted")}
                    </Typography>
                </StyledWrapper>
            </>
        </InventoryMessage>
    );

    const scratchAndDentIventoryTextComponent = (
        <InventoryMessage color={color} {...styles.inventoryMessage}>
            <>
                <StyledWrapper {...styles.stockIconMessageWrapper}>
                    <Typography
                        {...styles.stockAsciiIcon}
                        dangerouslySetInnerHTML={{
                            __html: getScratchAndDentAvailabilityIcon(canAddToCart, availability),
                        }}
                    ></Typography>
                    <Typography {...styles.messageText}>
                        {canAddToCart && <>{translate("Store_ProductAvailability_Available")}</>}
                        {(availability.StatusName === constants.availability.notAvailable || !canAddToCart) && (
                            <>{translate("This Scratch & Dents product has been sold")}</>
                        )}
                    </Typography>
                </StyledWrapper>
            </>
        </InventoryMessage>
    );

    const warehousePickupAvailabilityComponent = (warehouse: any) => {
        if (!warehouse) {
            return <></>;
        }
        return (
            <DataTableCell>
                {warehouse.Quantity > 0 && (
                    <>
                        {warehouse.Quantity} {translate("Store_ProductAvailability_PickUp_AvailableToday")}
                    </>
                )}
                {warehouse.Quantity === 0 && warehouse.PickUpDelay.MaximumDays === null && (
                    <>
                        {warehouse.PickUpDelay.MinimumDays === "0" &&
                            translate("Store_ProductAvailability_NotAvailable").replace(
                                "{}",
                                `${warehouse.PickUpDelay.MinimumDays}`,
                            )}
                        {warehouse.PickUpDelay.MinimumDays === 1 &&
                            translate("Store_ProductAvailability_PickUp_AvailableInNetworkMessage").replace(
                                "{}",
                                `${warehouse.PickUpDelay.MinimumDays}`,
                            )}
                        {warehouse.PickUpDelay.MinimumDays > 1 &&
                            translate("Store_ProductAvailability_PickUp_AvailableInNetworkMessage_Plural").replace(
                                "{}",
                                `${warehouse.PickUpDelay.MinimumDays}`,
                            )}
                    </>
                )}
                {warehouse.Quantity === 0 && warehouse.PickUpDelay.MaximumDays != null && (
                    <>
                        {translate("Store_ProductAvailability_PickUp_AvailableMessage_Range").replace(
                            "{range}",
                            `${warehouse.PickUpDelay.MinimumDays}-${warehouse.PickUpDelay.MaximumDays}`,
                        )}
                    </>
                )}
            </DataTableCell>
        );
    };

    const getAvailabilityWarehouseByName = (warehouseName: string) => {
        if (!availability.Warehouses) {
            return;
        }
        const extraData = availability.Warehouses.find((f: any) => f.DisplayName === warehouseName);
        return extraData;
    };

    const parseDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };

    const trackingUrls = (array: string[]) => {
        const cleanArray = array.filter(function (item, pos, self) {
            return self.indexOf(item) === pos;
        });
        return cleanArray;
    };

    const hasProductKitNumbers = availability.PurchaseOrders?.some(
        (p: any) => p.KitErpNumber != null && p.KitErpNumber !== "",
    );

    return (
        <>
            {isProductDetailsPage ? (
                <>
                    {isScratchAndDent === "True" ? (
                        <GridContainer {...styles.container}>
                            <GridItem {...styles.stockGridItemFull}>{scratchAndDentIventoryTextComponent}</GridItem>
                        </GridContainer>
                    ) : (
                        <GridContainer {...styles.container}>
                            <GridItem {...styles.stockGridItem}>{pickupIventoryTextComponent}</GridItem>
                            <GridItem {...styles.stockGridItem}>{shippingIventoryTextComponent}</GridItem>
                        </GridContainer>
                    )}
                </>
            ) : (
                <>
                    {isScratchAndDent === "True" ? (
                        <StyledWrapper>{scratchAndDentIventoryTextComponent}</StyledWrapper>
                    ) : (
                        <StyledWrapper>{inlineShippingIventoryTextComponent}</StyledWrapper>
                    )}
                </>
            )}
            <Modal
                {...styles.replenishmentModal}
                isOpen={replenishmentModalIsOpen}
                handleClose={replenishmentModalCloseHandler}
            >
                {isLoading && <Loader />}
                {!isLoading && (
                    <>
                        <Typography {...styles.modalTitles}>{translate("Future availability")}</Typography>
                        <DataTable>
                            <DataTableHead>
                                <DataTableHeader>
                                    {translate("Store_ProductAvailability_Replenishment_Quantity")}
                                </DataTableHeader>
                                <DataTableHeader>
                                    {translate("Store_ProductAvailability_Replenishment_Status")}
                                </DataTableHeader>
                                <DataTableHeader>
                                    {translate("Store_ProductAvailability_Replenishment_Date")}
                                </DataTableHeader>
                                <DataTableHeader>
                                    {translate("Store_ProductAvailability_Replenishment_Name")}
                                </DataTableHeader>
                                <DataTableHeader>
                                    {translate("Store_ProductAvailability_Replenishment_Address")}
                                </DataTableHeader>
                                <DataTableHeader>{translate("Tracking Info")}</DataTableHeader>
                                {hasProductKitNumbers && (
                                    <DataTableHeader>
                                        {translate("Store_ProductAvailability_KitProductNumber")}
                                    </DataTableHeader>
                                )}
                            </DataTableHead>
                            <DataTableBody>
                                {availability.PurchaseOrders?.map((order: any) => (
                                    <DataTableRow
                                        key={
                                            order.OrderNumber +
                                            order.FabricationStatus +
                                            order.Warehouse.Name +
                                            order.Warehouse.CountryId +
                                            order.Warehouse.Id
                                        }
                                    >
                                        <DataTableCell>{order.Quantity}</DataTableCell>
                                        <DataTableCell>{order.FabricationStatus}</DataTableCell>
                                        <DataTableCell>
                                            {order.IsInTransit &&
                                                translate("Store_ProductAvailability_Replenishment_InTransit")}
                                            {order.IsRunningLate &&
                                                translate("Store_ProductAvailability_Replenishment_RunningLate")}
                                            {order.ToBeScheduled &&
                                                translate("Store_ProductAvailability_Replenishment_ToBeScheduled")}
                                            {!order.ToBeScheduled &&
                                                !order.IsInTransit &&
                                                !order.IsRunningLate &&
                                                parseDate(order.ExpectedShipDate)}
                                        </DataTableCell>
                                        <DataTableCell>{order.Warehouse.Name}</DataTableCell>
                                        <DataTableCell>
                                            {order.Warehouse.Address1}, {order.Warehouse.City}, {order.Warehouse.State}{" "}
                                            {order?.Warehouse.Postalcode}
                                        </DataTableCell>
                                        <DataTableCell>
                                            {order.TrackingUrl &&
                                                order.TrackingUrl.length > 0 &&
                                                // eslint-disable-next-line array-callback-return
                                                trackingUrls(order.TrackingUrl)?.map((tracking: any) => {
                                                    if (tracking && tracking.length > 0) {
                                                        return (
                                                            <Link
                                                                key={
                                                                    order.OrderNumber + order.Warehouse.Name + tracking
                                                                }
                                                                data-test-selector="brandExternalUrlLink"
                                                                href={tracking}
                                                                target="_blank"
                                                                {...styles.trackingLink}
                                                            >
                                                                {tracking}
                                                            </Link>
                                                        );
                                                    }
                                                })}
                                        </DataTableCell>
                                        {hasProductKitNumbers && <DataTableCell>{order.KitErpNumber}</DataTableCell>}
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </>
                )}
            </Modal>
            <Modal isOpen={warehousesModalIsOpen} handleClose={warehousesModalCloseHandler}>
                {isLoading && <Loader />}
                {!isLoading && (
                    <>
                        {pickUpWarehouse && (
                            <>
                                <Typography {...styles.modalTitles}>{translate("My Store")}</Typography>
                                <DataTable>
                                    <DataTableHead>
                                        <DataTableHeader>{translate("Name")}</DataTableHeader>
                                        <DataTableHeader>{translate("Address")}</DataTableHeader>
                                        <DataTableHeader>{translate("Pickup Availability*")}</DataTableHeader>
                                    </DataTableHead>
                                    <DataTableBody>
                                        <DataTableRow>
                                            <DataTableCell>{pickUpWarehouse?.name}</DataTableCell>
                                            <DataTableCell>
                                                {pickUpWarehouse?.address1}, {pickUpWarehouse?.city},{" "}
                                                {pickUpWarehouse?.state} {pickUpWarehouse?.postalCode}
                                            </DataTableCell>
                                            {warehousePickupAvailabilityComponent(
                                                getAvailabilityWarehouseByName(pickUpWarehouse?.name),
                                            )}
                                        </DataTableRow>
                                    </DataTableBody>
                                </DataTable>
                            </>
                        )}
                        <Typography {...styles.modalTitles}>{translate("Nearby Stores")}</Typography>
                        <DataTable>
                            <DataTableHead>
                                <DataTableHeader>{translate("Name")}</DataTableHeader>
                                <DataTableHeader>{translate("Address")}</DataTableHeader>
                                <DataTableHeader>{translate("Pickup Availability*")}</DataTableHeader>
                            </DataTableHead>
                            <DataTableBody>
                                {warehouses?.map((warehouse: any) => (
                                    <DataTableRow key={warehouse.DisplayName}>
                                        <DataTableCell>{warehouse.DisplayName}</DataTableCell>
                                        <DataTableCell>
                                            {warehouse.Address1}, {warehouse.City}, {warehouse.State}{" "}
                                            {warehouse?.Postalcode}
                                        </DataTableCell>
                                        {warehousePickupAvailabilityComponent(warehouse)}
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                        <Typography {...styles.legalText}>
                            {translate("*Excludes holidays and weekends. Check store locator for hours.")}
                        </Typography>
                    </>
                )}
            </Modal>
        </>
    );
};

export default withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductAvailabilityWithPickup));
